import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/mobile/leaves_1048x1116.webp")